import checkValidUrl from '../../../helper/urls/checkValidUrl';
import booking from '../../booking';
import dom from '../../wrapper/DomWrapper';

class ServicePage {
  init = ({ id }) => {
    const { bookingService, bookingId, bookingUrl } = booking.provider;
    const url = `${bookingService}?site=${bookingId}&serviceId=${id}`;
    const isValidUrl = checkValidUrl(url);
    const elWrapper = dom.getElement('.booking-iframe');

    if (!isValidUrl || !elWrapper) return;

    const elIframe = dom.createElement('iframe');

    dom.on(dom.window, 'message', (e) => {
      const { data } = e || {};

      if (data?.type !== 'close') return;

      dom.window.location.assign(`/${bookingUrl}`);
    });

    dom.on(elIframe, 'load', () => {
      dom.removeClass(elWrapper, 'spinner');
    });

    elIframe.src = url;

    elWrapper.append(elIframe);
  };
}

export default ServicePage;
